import reduxStore from "../../../configureEnvStore";
import { GLOBAL_MEETING_DATA } from "../../../constants/PublicVariables";
import { showMeRoomTypeIsGoRoomOrP2P } from "../twilioCallUtility";
import { setCallParticipants } from "../../../reducers/common-reducer";
import { handleShowNetworkUnstableView } from "../../Network/NetworkUtils";

export const setParticipantNetworkQuality = (remoteParticipant) => {
    const handleRemoteNQLevelChanged = (remoteParticipant) => {
        const { joinMeetingData } = reduxStore.getState().joinMeeting;

        if (GLOBAL_MEETING_DATA.isAgent && !showMeRoomTypeIsGoRoomOrP2P(joinMeetingData?.sessionConfigurations)) {
            const callParticipants = reduxStore.getState().commonReducer.callParticipants;

            const updatedParticipants = [...callParticipants].map((user) => {
                if (user.identity == remoteParticipant.identity) {
                    return {
                        ...user,
                        networkQuality: remoteParticipant.networkQualityLevel,
                    };
                }
                return user;
            });
            reduxStore.dispatch(setCallParticipants(updatedParticipants));
            handleShowNetworkUnstableView(remoteParticipant.networkQualityLevel, "remote");
        }
    };

    remoteParticipant.on("networkQualityLevelChanged", () => {
        console.log("remote_networkQualityLevelChanged:" + remoteParticipant.networkQualityLevel);
        handleRemoteNQLevelChanged(remoteParticipant);
    });
};
